export default __webpack_public_path__ + "images/cursorWhite.18b6929.svg";